import config from 'config/config';

export enum ProfileFeedbackReplyStatus {
  approved = 'approved',
  pending = 'waiting_for_moderation',
}

export type FeedbackReply = {
  comment: string;
  status: ProfileFeedbackReplyStatus;
};

export type Feedback = {
  id: string;
  comment: string;
  value: number;
  createdAt: string;
  user: {
    id?: string;
    name: string;
    avatar: string;
    city?: string;
    gender?: string;
  };
  provider: {
    id?: string;
    slug?: string;
    avatar: string;
    name: string;
    city: string;
  };
  l4CategoryNames?: string[];
  category?: {
    name: string;
    slug: string;
  };
  files?: any[];
  reply?: FeedbackReply;
  preferredCategoryName?: string;
  categoryName?: string;
  isSameUser?: boolean;
  allowReply?: boolean;
  seen?: boolean;
  showProvider?: boolean;
  isExternal?: boolean;
};

export const sortCategories = (l4CategoryNames: string[], preferredCategoryName?: string): string[] => {
  if (preferredCategoryName && l4CategoryNames.includes(preferredCategoryName)) {
    const sortedCategories = l4CategoryNames.filter((categoryName) => categoryName !== preferredCategoryName);
    sortedCategories.unshift(preferredCategoryName);
    return sortedCategories;
  }

  return l4CategoryNames;
};

export const formatDate = (date: string): string => {
  return new Date(date).toLocaleDateString(config.LOCALE, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};
